const Loader = ({
  className = "h-screen bg-white justify-center mt-[15%]",
  insideClasses = "h-16 w-16 border-4",
}) => {
  return (
    <div className={`flex ${className}`}>
      <div
        className={`animate-spin rounded-full border-[#1c2434] border-t-transparent ${insideClasses}`}
      ></div>
    </div>
  );
};

export default Loader;
